module.exports = __webpack_public_path__ + "media/images/official/about_yamori_iga-c853afc82d4822a4c8a5fb36a511ed86.png";